/*
This component is used in LinkList and ItemList widget.
*/

import React from 'react'
import styled, { css } from 'styled-components'

import Card from 'js/components/Card/Card'
import { media } from 'js/lib/helpers'
import WidgetTitle from 'js/page/Widget/components/components/WidgetTitle'

type LayoutType = 'list' | 'grid' | 'carousel' | 'feed'

interface WrapperProps {
    $layout: LayoutType
    $noResults?: boolean
}

const Wrapper = styled.div<WrapperProps>`
    display: flex;
    flex-direction: column;

    .list-widget--title {
        ${(p) =>
            ['list', 'grid'].includes(p.$layout) &&
            css`
                ${media.mobileLandscapeDown`
                    padding: ${(p) =>
                        `${p.theme.padding.vertical.small} ${p.theme.padding.horizontal.small} 0`};
                `}

                ${media.tabletUp`
                    padding: ${(p) =>
                        `${p.theme.padding.vertical.normal} ${p.theme.padding.horizontal.normal} 0`};
                `};
            `};

        ${(p) =>
            p.$layout === 'grid' &&
            css`
                text-align: center;
            `};

        ${(p) =>
            ['carousel', 'feed'].includes(p.$layout) &&
            !p.$noResults &&
            css`
                margin-bottom: 12px;
            `};
    }
`

interface ListWidgetWrapperProps {
    title?: string
    widgetTitle: string
    layout: LayoutType
    noResults?: boolean
    children: React.ReactNode
    [key: string]: any
}

const ListWidgetWrapper = ({
    title,
    widgetTitle,
    layout,
    noResults,
    children,
    ...rest
}: ListWidgetWrapperProps) => {
    return (
        <Wrapper
            as={['list', 'grid'].includes(layout) ? Card : undefined}
            $layout={layout}
            $noResults={noResults}
            {...rest}
        >
            <WidgetTitle
                title={title}
                widgetTitle={widgetTitle}
                className="list-widget--title"
            />
            {children}
        </Wrapper>
    )
}

export default ListWidgetWrapper
